import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react';

type AnalyticsConsentUiValue = {
  /** Incremented to reopen the analytics consent bar from the header link. */
  settingsNonce: number;
  openCookieSettings: () => void;
};

const AnalyticsConsentUiContext = createContext<AnalyticsConsentUiValue | null>(null);

export function AnalyticsConsentUiProvider({ children }: { children: ReactNode }) {
  const [settingsNonce, setSettingsNonce] = useState(0);

  const openCookieSettings = useCallback(() => {
    setSettingsNonce((n) => n + 1);
  }, []);

  const value = useMemo(
    () => ({ settingsNonce, openCookieSettings }),
    [settingsNonce, openCookieSettings],
  );

  return (
    <AnalyticsConsentUiContext.Provider value={value}>{children}</AnalyticsConsentUiContext.Provider>
  );
}

export function useAnalyticsConsentUi(): AnalyticsConsentUiValue {
  const ctx = useContext(AnalyticsConsentUiContext);
  if (!ctx) {
    throw new Error('useAnalyticsConsentUi must be used within AnalyticsConsentUiProvider');
  }
  return ctx;
}
